var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingData),expression:"loadingData"}],ref:"dialog",attrs:{"title":"Edit Pick Up Info","inputs-map":_vm.truckInfo,"input-value-change":_vm.valueChange,"save-cb":_vm.saveTruckInfo,"reset-inputs":_vm.resetTruckInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }